import React, { memo } from 'react';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Slider from '@mui/material/Slider';

import {
  useStyles,
  useStylesGrid,
  useStylesSlider,
  useStylesTypography,
} from './styles';

function FlavourPreferenceSlider({
  id,
  value,
  handleChangeValueSlider,
  left,
  right,
}) {
  const classes = useStyles();
  const classesSlider = useStylesSlider();
  const classesGrid = useStylesGrid();
  const classesTypography = useStylesTypography();

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={2}>
            <Grid item xs={6} classes={classesGrid}>
              <Typography
                align="left"
                className={clsx(
                  classesTypography.label,
                  classesTypography.left,
                )}
              >
                {left}
              </Typography>
            </Grid>
            <Grid item xs={6} classes={classesGrid}>
              <Typography
                align="right"
                className={clsx(
                  classesTypography.label,
                  classesTypography.right,
                )}
              >
                {right}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Slider
                aria-label={id}
                min={0}
                max={1}
                step={0.01}
                value={value}
                onChange={handleChangeValueSlider}
                classes={classesSlider}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

export default memo(FlavourPreferenceSlider);
